import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import _cloneDeep from "lodash/cloneDeep";
var _excluded = ["text", "url", "type"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import classnames from 'classnames';
import { Button } from "../../Button/Button/Button";
import { HeadingText } from "../../Text/HeadingText/HeadingText";
import { MatchHeightElement } from "../../Utility/MatchHeight/MatchHeightElement";
import { PricingForm } from "../../Price/PricingForm/PricingForm";
import { RecommendedFlag } from "../../Flag/RecommendedFlag/RecommendedFlag";
import { TextPrice, defaultPropsTextPrice } from "../../Price/TextPrice/TextPrice";
import { Text } from "../../Text/Text/Text";
import { useShowHidePricingFormWithZip } from "../../Utility/Hooks";
import styles from "./PlanSquare.module.scss";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var planSquareTypog = ['headline5', 'headline6', 'headline7', 'headline8'];
export var PlanSquare = function PlanSquare(_ref) {
  var title = _ref.title,
    _ref$subhead = _ref.subhead,
    subhead = _ref$subhead === void 0 ? '' : _ref$subhead,
    _ref$flag = _ref.flag,
    flag = _ref$flag === void 0 ? '' : _ref$flag,
    _ref$first = _ref.first,
    first = _ref$first === void 0 ? true : _ref$first,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className,
    _ref$cta = _ref.cta,
    cta = _ref$cta === void 0 ? {} : _ref$cta,
    textPrice = _ref.textPrice,
    _ref$typogPriceText = _ref.typogPriceText,
    typogPriceText = _ref$typogPriceText === void 0 ? 'headline5' : _ref$typogPriceText,
    pricing = _ref.pricing,
    _ref$showPricingForm = _ref.showPricingForm,
    showPricingFormInit = _ref$showPricingForm === void 0 ? false : _ref$showPricingForm,
    errorMessage = _ref.errorMessage;
  var _useShowHidePricingFo = useShowHidePricingFormWithZip(showPricingFormInit),
    autoFocus = _useShowHidePricingFo.autoFocus,
    showPricingForm = _useShowHidePricingFo.showPricingForm,
    onZipClick = _useShowHidePricingFo.onZipClick;
  var renderButton = function renderButton() {
    var text = cta.text,
      url = cta.url,
      type = cta.type,
      otherProps = _objectWithoutProperties(cta, _excluded);
    return /*#__PURE__*/_jsx(Button, _objectSpread(_objectSpread({
      className: styles.button,
      url: url,
      type: "secondary"
    }, otherProps), {}, {
      children: text
    }));
  };
  var renderedPricing = pricing ? _cloneDeep(pricing) : false;
  if (renderedPricing && renderedPricing.input) {
    renderedPricing.input.autoFocus = autoFocus;
  }
  return /*#__PURE__*/_jsxs("div", {
    children: [flag && /*#__PURE__*/_jsx("div", {
      className: styles.flag,
      children: /*#__PURE__*/_jsx(RecommendedFlag, {
        text: flag,
        className: styles.flagText
      })
    }), /*#__PURE__*/_jsx("div", {
      className: classnames(styles.plan, !first && styles.planN),
      children: /*#__PURE__*/_jsxs(MatchHeightElement, {
        group: "plan",
        children: [/*#__PURE__*/_jsx("div", {
          className: styles.title,
          children: /*#__PURE__*/_jsx(MatchHeightElement, {
            group: "title-text",
            children: /*#__PURE__*/_jsx(HeadingText, {
              ariaLevel: 2,
              typog: "subhead2",
              className: styles.titleText,
              children: title
            })
          })
        }), /*#__PURE__*/_jsx("div", {
          className: styles.subhead,
          children: subhead && /*#__PURE__*/_jsx(MatchHeightElement, {
            group: "subhead-text",
            children: /*#__PURE__*/_jsx(Text, {
              typog: "bodycopyLarge",
              richText: true,
              className: styles.subheadText,
              children: subhead
            })
          })
        }), /*#__PURE__*/_jsxs("div", {
          className: classnames(className, styles.square),
          children: [/*#__PURE__*/_jsx("div", {
            className: styles.priceTextContainer,
            children: /*#__PURE__*/_jsx(MatchHeightElement, {
              group: "price-text",
              children: /*#__PURE__*/_jsx(TextPrice, {
                text: textPrice !== null && textPrice !== void 0 && textPrice.text ? textPrice.text : defaultPropsTextPrice.text,
                price: textPrice !== null && textPrice !== void 0 && textPrice.price ? textPrice.price : defaultPropsTextPrice.price,
                className: styles.priceText,
                priceClass: styles.price,
                typogPriceText: typogPriceText
              })
            })
          }), (errorMessage === null || errorMessage === void 0 ? void 0 : errorMessage.text) && /*#__PURE__*/_jsx(Text, {
            typog: "bodycopySmall",
            className: classnames({
              [styles.errorMsg]: true,
              [styles.errorMsgRed]: errorMessage.red
            }),
            children: errorMessage.text
          }), (cta === null || cta === void 0 ? void 0 : cta.url) && (cta === null || cta === void 0 ? void 0 : cta.text) && /*#__PURE__*/_jsxs("div", {
            className: styles.buttonPricing,
            children: [!showPricingForm && renderButton(), renderedPricing && /*#__PURE__*/_jsx(PricingForm, {
              zipTypog: "bodycopySmall",
              pricing: renderedPricing,
              zipClassName: styles.zip,
              isOpen: showPricingForm,
              onZipClick: onZipClick
            })]
          })]
        })]
      })
    })]
  });
};